import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { EditCategoriePage } from "@/features/ventes/components/categories/EditCategoriePage";

export const Route = createFileRoute("/_app/ventes/categories/$id/edit")({
  loader: requirePermission(PERMISSIONS.VENTES.CATEGORIES.EDIT),
  staticData: {
    title: "Modifier catégorie",
    showInBreadcrumb: true,
  },
  component: EditCategoriePage,
});
